import PricingTable from '@/components/sections/PricingTable'
import { getServicePackages } from '@/content/serviceCatalog'

const packages = getServicePackages('design')

export default function DesignPricing() {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-primary relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('/assets/bg-noise.png')] opacity-5 mix-blend-overlay pointer-events-none" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent/10 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent/10 rounded-full blur-[120px] translate-y-1/2 -translate-x-1/2 pointer-events-none" />

      <div className="container relative z-10">
        <div className="text-center mb-8 md:mb-20">
          <h2 className="text-sm font-bold text-accent uppercase tracking-[0.2em] mb-6">Pricing</h2>
          <h3 className="text-4xl md:text-6xl font-bold font-heading text-white leading-[0.95] uppercase tracking-tight mb-6">
            Design <span className="text-accent">Packages</span>
          </h3>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            From a focused refresh to a full identity system. Choose the package that matches your ambition.
          </p>
        </div>

        <PricingTable packages={packages} />
        <p className="text-center text-slate-500 text-sm mt-10 max-w-xl mx-auto">
          Prices are guides. We&apos;ll tailor scope and pricing to fit your business and budget.
        </p>
      </div>
    </section>
  )
}
